import { render, staticRenderFns } from "./Character.vue?vue&type=template&id=df60d09c&scoped=true"
import script from "./Character.vue?vue&type=script&lang=js"
export * from "./Character.vue?vue&type=script&lang=js"
import style0 from "./Character.vue?vue&type=style&index=0&id=df60d09c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df60d09c",
  null
  
)

export default component.exports